import TableContext from '../../components/context-menu/TableContext';

export default class CreateTimesheetColumns {
  execute(source, translation) {
    const columnDefs = [{
        rowDrag: true,
        editable: false,
        pinned: 'right',
        width: 70,
        rowDragText: (params) => params.rowNode.data.name,
      },
      {
        field: 'name',
        headerName: '',
        editable: 'false',
        lockPosition: true,
        cellEditor: 'numericEditor',
        headerClass: 'timesheet-column-header',
        cellClass: (params) => {
          let res = 'font-bold';

          if (params.node.rowPinned === 'bottom') {
            res += ' border-black border-solid border-0 border-t';
          }

          return res;
        },
        onCellContextMenu: (cellContextMenuEvent) => {
          if (cellContextMenuEvent.rowPinned) {
            return;
          }

          this.$root.$emit('contextmenu', {
            event: cellContextMenuEvent.event,
            ctxMenuWidget: {
              component: TableContext,
              props: {
                isHidden: cellContextMenuEvent.data.isHidden,
                onHideClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.setItemVisibility(cellContextMenuEvent);
                },
                onShowClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.setItemVisibility(cellContextMenuEvent);
                },
              },
            },
          });
        },
      },
    ];
    source.columns.forEach((column) => {
      const columnDef = {
        field: column.columnId,
        headerName: translation('timesheetsPage.columnHeader', {
          columnId: column.columnId
        }),
        headerClass: 'timesheet-column-header',
        cellEditor: 'numericEditor',
        editable: ({
          data
        }) => {
          const editable = column.editable;
          if (!data.immutable && editable) return true;
          return false;
        },
        width: 150,
        onCellValueChanged: (event) => this.handleTimesheetCellValueChanged(event),
        pinnedTopCellRenderer: () => {
          return column.columnId;
        },
        cellClass: (params) => {
          let res = '';

          if (params.node.rowPinned === 'bottom') {
            res += 'border-black border-solid border-0 border-t';
          }

          return res;
        },
        onCellContextMenu: async (cellContextMenuEvent) => {
          // do not show in pinned columns
          if (cellContextMenuEvent.rowPinned) {
            return;
          }

          // do no show in total-fact and total-plan columns
          if (cellContextMenuEvent.column.colId.startsWith('total')) {
            return;
          }

          await this.gridApiProjects.stopEditing(false);


          this.$root.$emit('contextmenu', {
            event: cellContextMenuEvent.event,
            ctxMenuWidget: {
              component: TableContext,
              props: {
                isHidden: cellContextMenuEvent.data.isHidden,
                onAddWorkReportClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.editWorkReport(cellContextMenuEvent);
                },
              },
            },
          });
        },
      };
      columnDefs.push(columnDef);
    });
    return columnDefs;
  }
}
